import { render, staticRenderFns } from "./ApplyCertificate.vue?vue&type=template&id=52f27f62&scoped=true"
import script from "./ApplyCertificate.vue?vue&type=script&lang=js"
export * from "./ApplyCertificate.vue?vue&type=script&lang=js"
import style0 from "./ApplyCertificate.vue?vue&type=style&index=0&id=52f27f62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f27f62",
  null
  
)

export default component.exports